import { Form, Input, Modal } from 'antd';
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { investorAccountPendingDepositRejectAction } from './actions';

interface IState {
    reason: string;
}

interface IProps {
    accountUuid: string;
    onCancel: () => void;
}

interface IPropsDispatch {
    reject: (reason: string) => void;
}

type Props = IProps & IPropsDispatch;

class PendingDepositRejectModal extends React.Component<Props, IState> {
    public state: IState = {
        reason: null,
    };

    constructor(props: Props) {
        super(props);

        this.onChangeReason = this.onChangeReason.bind(this);
        this.onClickOk = this.onClickOk.bind(this);
    }

    public render(): JSX.Element {
        const { accountUuid } = this.props;
        const { reason } = this.state;

        return (
            <Modal
                okButtonProps={{ danger: true }}
                okText='Reject'
                onCancel={this.props.onCancel}
                onOk={this.onClickOk}
                open={!!accountUuid}
                title='Reject Deposit'
            >
                <Form.Item label='Reason' className='reason'>
                    <Input onChange={this.onChangeReason} value={reason} />
                </Form.Item>
            </Modal>
        );
    }

    private onChangeReason(event: React.ChangeEvent<HTMLInputElement>) {
        this.setState({
            reason: event.target.value,
        });
    }

    private onClickOk() {
        const { reason } = this.state;

        this.props.reject(reason);
        this.props.onCancel();
    }
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: IProps): IPropsDispatch {
    return {
        reject: (reason: string) => dispatch(investorAccountPendingDepositRejectAction(ownProps.accountUuid, reason)),
    };
}

export default connect(
    null,
    mapDispatchToProps,
)(PendingDepositRejectModal);
